// src/components/sections/Features.jsx

import React from 'react';

const featuresData = [
    { 
        icon: 'fa-bolt', 
        title: 'Lightning Fast', 
        text: 'Execute orders in under 100ms thanks to Solana’s speed and our optimized matching engine.' 
    },
    { 
        icon: 'fa-shield-halved', 
        title: 'MEV Protected', 
        text: 'Proprietary technology protects against front-running and guarantees fair price execution.' 
    },
    { 
        icon: 'fa-network-wired', 
        title: 'Decentralized Orderbook', 
        text: 'Trade with transparency and security on a fully decentralized, permissionless platform.' 
    },
    { 
        icon: 'fa-handshake', 
        title: 'Deep Liquidity', 
        text: 'Aggregated liquidity from top Solana DEXs ensures minimal slippage on large orders.' 
    },
];

const Features = () => (
    <section className="features">
        <div className="container">
            <div className="section-title fade-in">
                <h2>Why Choose <span>Kinetix</span>?</h2>
                <p>A suite of tools and features designed to give professional traders the edge in the crypto market.</p>
            </div>

            <div className="features-grid">
                {featuresData.map((feature, index) => (
                    <div 
                        key={index} 
                        className="feature-card scale-in" 
                        style={{ transitionDelay: `${index * 0.1}s` }}
                    >
                        <div className="feature-icon">
                            {/* ✅ Correct Font Awesome class */}
                            <i className={`fa-solid ${feature.icon}`}></i>
                        </div>

                        <h3>{feature.title}</h3>
                        <p>{feature.text}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Features;
